import React, { useState, useEffect } from 'react';
import { TextField, InputLabel, Button, Select, MenuItem, FormControl } from '@mui/material';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentsPrint from './PaymentsPrint';

const NewVendorPaymentForm = ({ isOpen, onClose, selectedRowData, createdID }) => {

    const [Vendor, setVendor] = useState('');
    const [VendorID, setVendorID] = useState('');
    const [PaymentType, setPaymentType] = useState('');
    const [PaymentDate, setPaymentDate] = useState('');
    const [Amount, setAmount] = useState('');
    const [Notes, setNotes] = useState('');
    const [Vendordata, setVendorData] = useState([]);
    const [SelectedImageFile, setSelectedImageFile] = useState(null);
    const [chequeNumber, setChequeNumber] = useState('')
    const [refNumber, setRefNumber] = useState('')

    const fetchData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/vendors/all_vendors`);
            const responseData = await response.json();
            if (responseData) {
                const VendorsWithData = responseData.vendor.map((Vendor) => ({
                    id: Vendor.id,
                    vendortitle: Vendor.vendortitle
                }));
                setVendorData(VendorsWithData);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const initializeForm = () => {
        if (selectedRowData !== null) {
            setVendorID(selectedRowData.id);
            setVendor(selectedRowData.vendorname);
            setPaymentType(selectedRowData.paymenttype);
            setPaymentDate(selectedRowData.paymentdate);
            setAmount(selectedRowData.amountstatus);
            setNotes(selectedRowData.notes || '');
            setRefNumber(selectedRowData.refnumber || '');
            setChequeNumber(selectedRowData.chequenumber || '')
        } else {
            setSelectedImageFile(null)
            setVendorID('');
            setVendor('');
            setPaymentDate('');
            setPaymentType('');
            setAmount('');
            setNotes('');
            setRefNumber('')
            setChequeNumber('')
        }
    };

    const fetchDataAndInitializeForm = async () => {
        await fetchData();
        initializeForm();
    };

    useEffect(() => {
        fetchDataAndInitializeForm();
    }, [selectedRowData]);

    const postData = async () => {
        if (!Vendor || !PaymentDate || !PaymentType || !Amount) {
            console.log("EMPTY FIELD");
        } else {
            const formData = new FormData();
            formData.append('vendorid', VendorID);
            formData.append('vendorname', Vendor);
            formData.append('paymentdate', PaymentDate);
            formData.append('paymenttype', PaymentType);
            formData.append('amount', Amount);
            if(PaymentType==="Bank Transfer"){
                formData.append('notes', `Ref Number:${refNumber}, ${Notes}`);
                }
            else if(PaymentType==="Cheque"){
                formData.append('notes', `Cheque No.:${chequeNumber}, ${Notes}`);
                }
            else {
                formData.append('notes', Notes);
            }
            formData.append('chequenumber', chequeNumber);
            formData.append('refnumber', refNumber);
            formData.append('chequeimage', SelectedImageFile);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };

            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/vendors/make_payment`,
                    formData,
                    config
                );

                if (response.status === 200) {
                    toast("Payment created successfully!", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    createdID(parseInt(response.data.vendor));
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const updateData = async () => {
        // Handle update data if needed
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (selectedRowData) {
            await updateData();
        } else {
            await postData();
        }

        initializeForm();
    };

    return (
        <div style={{
            display: isOpen ? 'block' : 'none',
            position: 'fixed',
            height: '80vh',
            overflowY: 'auto',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            zIndex: '999',
            backdropFilter: 'blur(5px)',
        }}>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <h2 className='text-2xl font-bold font-poppins ml-2 mt-3 mb-3'>{selectedRowData ? "Update payment" : "Add New Payment"}</h2>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <FormControl fullWidth>
                    <InputLabel id="Vendor">Vendor</InputLabel>
                    <Select
                        labelId="Vendor"
                        id="Vendor"
                        value={Vendor}
                        label="Vendor"
                        onChange={(e) => {
                            const selectedVendor = e.target.value;
                            setVendor(selectedVendor);

                            const selectedVendorData = Vendordata.find(Vendor => Vendor.vendortitle === selectedVendor);
                            if (selectedVendorData) {
                                setVendorID(selectedVendorData.id)
                            }
                        }}
                        sx={{ mb: 4 }}
                    >
                        {Vendordata.map((Vendor, index) => (
                            <MenuItem key={index} value={Vendor.vendortitle}>
                                {Vendor.vendortitle}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    type="date"
                    variant="outlined"
                    color="secondary"
                    onChange={(e) => setPaymentDate(e.target.value)}
                    value={PaymentDate}
                    fullWidth
                    required
                    sx={{ mb: 4 }}
                />
                <FormControl fullWidth>
                    <InputLabel id="payment-type">Payment Type</InputLabel>
                    <Select
                        labelId="payment-type"
                        id="payment-type"
                        value={PaymentType}
                        label="Payment Type"
                        onChange={(e) => setPaymentType(e.target.value)}
                        sx={{ mb: 4 }}
                    >
                        <MenuItem value="Cash">Cash</MenuItem>
                        <MenuItem value="Cheque">Cheque</MenuItem>
                        <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                        {/* <MenuItem value="Credit">Credit Note</MenuItem> */}
                    </Select>
                </FormControl>


                {PaymentType === "Cheque" && (
                    <>
                        <TextField
                            type="text"
                            variant="outlined"
                            color="secondary"
                            label="Cheque Number"
                            onChange={(e) => setChequeNumber(e.target.value)}
                            value={chequeNumber}
                            fullWidth
                            sx={{ mb: 4 }}
                        />
                    </>
                )}
                {PaymentType === "Bank Transfer" && (
                    <>
                        <TextField
                            type="text"
                            variant="outlined"
                            color="secondary"
                            label="Ref. Number"
                            onChange={(e) => setRefNumber(e.target.value)}
                            value={refNumber}
                            fullWidth
                            sx={{ mb: 4 }}
                        />
                    </>
                )}


                <TextField
                    type="number"
                    variant="outlined"
                    color="secondary"
                    label="Amount"
                    onChange={(e) => setAmount(e.target.value)}
                    value={Amount}
                    fullWidth
                    required
                    sx={{ mb: 4 }}
                />

                <TextField
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="Descripiton (Optional)"
                    onChange={(e) => {
                        setNotes(e.target.value)
                    }}
                    value={Notes}
                    fullWidth
                    sx={{ mb: 4 }}
                />

                <div style={{ display: PaymentType === "Cheque" ? "block" : "none" }}>
                    <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="raised-button-file"
                        type="file"
                        name="chequeimage" // Ensure this matches the middleware setup
                        onChange={(e) => {
                            const file = e.target.files[0];
                            setSelectedImageFile(file);
                        }}
                    />
                    <label htmlFor="raised-button-file">
                        <Button className='w-[120px]' variant="raised" component="span">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
                            </svg>
                        </Button>
                    </label>
                    {SelectedImageFile && (
                        <div>
                            <img
                                src={URL.createObjectURL(SelectedImageFile)}
                                alt="Selected"
                                style={{ maxWidth: '50%', maxHeight: '50px' }}
                            />
                        </div>
                    )}
                </div>

                <button
                    type='submit'
                    className='w-[120px] text-white rounded font-bold font-poppins bg-[#007FFF] p-2 mr-5 mt-2 mb-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
                >
                    {selectedRowData ? "Update Payment" : "Add Payment"}
                </button>
            </form>
            <button
                onClick={onClose}
                className='w-[120px] text-red-500 border border-red-500 rounded font-bold font-poppins bg-white p-2 mr-5 mt-2 mb-2 hover:bg-red-500 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
            >
                Close
            </button>

        </div>
    );


};

export default NewVendorPaymentForm;
